@if (activity(); as activity) {
	@if(activity.first_skill_code) {
		<app-cms-badge [color]="activity.first_skill_code[0]">{{ activity.first_skill_code[0].toUpperCase() }}</app-cms-badge>
	}
}
